export const authAPI = {
    async authenticate(email, password) {
        const jsonBody = JSON.stringify({
            email: email,
            password: password,
        });

        const resp = await fetch("/api/authentication", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: jsonBody,
        }).catch((e) => console.log(e));

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
            };
        }

        if (body.validationErrors) {
            return {
                ok: false,
                err: "",
            };
        }

        if (body.err) {
            if (body.err === "user not found") {
                return {
                    ok: false,
                    err: "user_not_found",
                };
            }
            if (body.err === "incorrect password") {
                return {
                    ok: false,
                    err: "incorrect_password",
                };
            }

            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    },

    async registrate(name, email, password, userType) {
        const jsonBody = JSON.stringify({
            name: name,
            email: email,
            password: password,
            "user-type": userType,
        });

        const resp = await fetch("/api/registration", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: jsonBody,
        }).catch((e) => console.log(e));

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
            };
        }

        if (body.validationErrors) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        if (body.err) {
            if (body.err === "user with the same email already exists") {
                return {
                    ok: false,
                    err: "user_with_the_same_email_already_exists",
                };
            }
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    },

    async refreshToken() {
        let resp = await fetch("/api/authentication/refresh", {
            method: "POST",
            credentials: "include"
        }).catch((e) =>
            console.log(e)
        );

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (body.ok) {
            return true
        }

        return false
    },

    async resetPassword(email, language) {
        const jsonBody = JSON.stringify({
            email: email,
            language: language,
        });

        const resp = await fetch("/api/user/reset-password", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: jsonBody,
        }).catch((e) => console.log(e));

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
            };
        }

        if (body.validationErrors) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        if (body.err) {
            if (body.err === "user not found") {
                return {
                    ok: false,
                    err: "user_not_found",
                };
            }
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    },

    async confirmResetPassword(password, token) {
        const jsonBody = JSON.stringify({
            "new-password": password,
        });

        const resp = await fetch("/api/user/reset-password/confirm?uid="+token, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: jsonBody,
        }).catch((e) => console.log(e));

        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if (!body) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
            };
        }

        if (body.validationErrors) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        if (body.err) {
            if (body.err === "reset password session not found") {
                return {
                    ok: false,
                    err: "reset_password_session_not_found",
                };
            }
        }

        return {
            ok: false,
            err: "something_went_wrong",
        };
    }
};
